/**
 * The campaigns (streams) list query, shared by `useCampaigns` in queries.ts
 * and the menu (`layout/navUser.ts`), which reads its `money` to decide the
 * Money items. Its own module so the menu does not pull in every query.
 */
import { api, unwrap } from './client';

export const CAMPAIGNS_KEY = ['campaigns'] as const;

export async function fetchCampaigns() {
  return unwrap(await api.GET('/api/v1/campaigns', {}), 'CampaignListResponse');
}

/** Five minutes: the list feeds every filter dropdown, and routing edits invalidate it. */
export const CAMPAIGNS_STALE = 5 * 60 * 1000;
